import type { TypeTableColumn } from '@thefarmersfront/kitchen';

import type { TypeAddGoodsModalGoods } from '~/types/receive.types';

type GetReceiveAddGoodsModalColumnDefsParams = {
  hasPermissionNFA: boolean;
  /** 이미 등록된 상품코드 목록 (중복 선택 방지용) */
  registeredGoodsCodes?: string[];
};

/**
 * [입고관리 > 입고요청관리] 입고상품추가 모달 테이블
 *
 * 이미 등록된 상품은 선택할 수 없고 흐리게 보인다(isRowSelectable 로 Table selection 에 넘긴다).
 */
const getReceiveAddGoodsModalColumnDefs = ({
  hasPermissionNFA,
  registeredGoodsCodes = [],
}: GetReceiveAddGoodsModalColumnDefsParams) => {
  const registeredGoodsCodesSet = new Set(registeredGoodsCodes);

  const isRowSelectable = (row: TypeAddGoodsModalGoods) =>
    !row.goodsCode || !registeredGoodsCodesSet.has(row.goodsCode);

  const columnDefs: TypeTableColumn<TypeAddGoodsModalGoods>[] = [
    {
      id: 'selection',
      header: '',
      cell: () => null,
      size: 44,
      meta: { selection: true },
    },
    {
      accessorKey: 'goodsCode',
      header: '상품코드',
      size: 140,
    },
    ...(hasPermissionNFA
      ? [{ accessorKey: 'nsid', header: 'NSID', size: 180 } satisfies TypeTableColumn<TypeAddGoodsModalGoods>]
      : []),
    {
      accessorKey: 'alternativeCode',
      header: '상품바코드',
      size: 150,
    },
    {
      accessorKey: 'goodsName',
      header: '상품명',
      minSize: 240,
      meta: { flex: true },
    },
    {
      accessorKey: 'mainCategoryDesc',
      header: '대분류',
      size: 140,
    },
    {
      accessorKey: 'middleCategoryDesc',
      header: '중분류',
      size: 140,
    },
    {
      accessorKey: 'thirdCategoryDesc',
      header: '소분류',
      size: 140,
    },
    {
      accessorKey: 'kurlyKeepTypeDesc',
      header: '보관유형',
      size: 100,
    },
    {
      accessorKey: 'shelfLifeTypeDesc',
      header: '유통/소비기한',
      size: 140,
    },
  ];

  return { columnDefs, isRowSelectable };
};

export default getReceiveAddGoodsModalColumnDefs;
